export default "__VITE_ASSET__85acb3a3__"